import React, {Component, useState} from 'react';
import {useDispatch} from "react-redux";
import {Link, useHistory} from "react-router-dom";
import ModalAlerterCallback from "../../utils/ModalAlerterCallback";
import TableCell from "@mui/material/TableCell";
import {TableSortLabel} from "@mui/material";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Grid from "@mui/material/Grid";
import {ContainerHeader, SortableTableMat, AdvanceSearchUsers} from "../../module";
import moment from 'jalali-moment'
import {makeStyles} from "@mui/styles";
import {deleteUser} from "../../../stores/user/userThunk";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        alignItems: 'center',
        padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    actions: {
        display: 'flex !important',
        flexDirection: 'row',
        gap: '0 10px'
    },
    editIcon: {
        color: '#FF8C00',
    },
    deleteIcon: {
        color: 'red',
    },
    viewEx: {
        color: '#0054a7',
    },
    item: {
        padding: '16px 8px',
    },
}));

const headCells = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: 'شناسه',
    },
    {
        id: 'first_name',
        numeric: false,
        disablePadding: false,
        label: 'نام',
    },
    {
        id: 'last_name',
        numeric: false,
        disablePadding: false,
        label: 'نام خانوادگی',
    },
    {
        id: 'mobile',
        numeric: false,
        disablePadding: false,
        label: 'موبایل',
    },
    {
        id: 'created_at',
        numeric: false,
        disablePadding: false,
        label: 'تاریخ عضویت',
    },
    {
        id: 'action',
        numeric: false,
        disablePadding: false,
        label: '',
        sort: true,
    },
];

export default function AdminUsers() {

    const dispatch = useDispatch();
    const history = useHistory();
    const [params, setParams] = useState({
        first_name:"",
        last_name:"",
        email:"",
        mobile: ""
    });

    function removeUser(user_id, refreshTable) {
        const callback = () =>
            dispatch(deleteUser(user_id, refreshTable));
        ModalAlerterCallback(callback);
    }

    const ExerciseHeadMedel = (props) => {
        const classes = useStyles();
        const {headCell, order, orderBy} = props;

        return (
            <TableCell
                key={headCell.id}
                align={headCell.numeric ? 'right' : 'left'}
                padding={headCell.disablePadding ? 'none' : 'normal'}
                sortDirection={orderBy === headCell.id ? order : false}
            >
                <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : 'asc'}
                    // onClick={createSortHandler(headCell.id)}
                >
                    {headCell.label}
                    {orderBy === headCell.id ? (
                        <span className={classes.visuallyHidden}>
            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
          </span>
                    ) : null}
                </TableSortLabel>
            </TableCell>
        );
    };

    const ExerciseRowTableModel = (props) => {
        const classes = useStyles();
        const {row, onRemove, refreshTable} = props;

        function handleRemove() {
            onRemove({user_id: row.id}, refreshTable);
        }

        const date = row?.created_at;
        return (
            <TableRow hover tabIndex={-1} key={row.id}>
                <TableCell align="left">{row?.id}</TableCell>
                <TableCell align="left">{row?.first_name}</TableCell>
                <TableCell align="left">{row?.last_name}</TableCell>
                <TableCell align="left">{row?.mobile}</TableCell>
                <TableCell align="left" dir="ltr">{date}</TableCell>
                <TableCell align="left" className={classes.actions}>
                    <Link to={`/adminUser/${row.id}`}>
                        <Tooltip title="ویرایش">
                            <IconButton>
                                <EditIcon/>
                            </IconButton>
                        </Tooltip>
                    </Link>
                    <div onClick={handleRemove}>
                        <Tooltip title="حذف">
                            <IconButton>
                                <DeleteIcon/>
                            </IconButton>
                        </Tooltip>
                    </div>
                </TableCell>
            </TableRow>
        );
    };

    function addUser() {
        history.push('/adminUser');
    }

    return (
        <Grid item xs={11} sm={12} className="d-flex flex-column DivParentCreateProduct">
            <ContainerHeader
                data={{
                    filter: false,
                    addBtn: true,
                }}
                headerTitle="لیست مدیران"
                titleBtn="افزودن"
                addBtnAction={addUser}
                // filterAction={(value) => {
                //     handleSearch(value);
                // }}
            />

            <div style={{ marginBottom: 8 }}>
                <AdvanceSearchUsers setParams={setParams} />
            </div>

            <SortableTableMat
                link={'admin/admin'}
                RowComponent={ExerciseRowTableModel}
                HeadCompnent={ExerciseHeadMedel}
                headers={headCells}
                onRemove={removeUser}
                preParams={params}
            />
        </Grid>
    );
}